import { Text } from '@goodfynd/react-web.lib.ui';

import { styled } from '../../../theme/stitches.config';

export const StyledContainer = styled('section', {
  backgroundColor: '$Neutral01',
  padding: '80px 150px',
  '@mdMax': {
    padding: '40px 24px',
  },
});

export const StyledDescription = styled(Text, {
  marginTop: 8,
});

export const StyledItem = styled('article', {
  marginTop: 32,
  '@xs': {
    alignItems: 'flex-start',
    display: 'flex',
    justifyContent: 'space-between',
    '.img': {
      marginRight: 16,
    },
  },
});
